import { render, staticRenderFns } from "./same_issuer.vue?vue&type=template&id=54d61e32&scoped=true"
import script from "./same_issuer.vue?vue&type=script&lang=js"
export * from "./same_issuer.vue?vue&type=script&lang=js"
import style0 from "./same_issuer.vue?vue&type=style&index=0&id=54d61e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d61e32",
  null
  
)

export default component.exports